import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=70a7a80e&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"
import style0 from "./NavigationComponent.vue?vue&type=style&index=0&id=70a7a80e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7a80e",
  null
  
)

export default component.exports